import * as React from 'react'
import { SVGProps } from 'react'

function SvgComponent(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.width ?? 24}
      height={props.height ?? 24}
      fill="none"
      {...props}
    >
      <g
        stroke={props.color ?? '#fff'}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={1.5}
        clipPath="url(#a)"
      >
        <path d="m16.5 14.25 4.5-4.5-4.5-4.5M18 20.25H3v-12" />
        <path d="M6.75 16.5a9 9 0 0 1 8.719-6.75H21" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h24v24H0z" />
        </clipPath>
      </defs>
    </svg>
  )
}
export default SvgComponent
